<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { IconButton, Loader, Text } from '@Shelly/shelly-design-system';
	// Helpers
	import {
		getPVSetupChartsConfig,
		getPVSetupDevices,
		getPVSetupByType,
		getPVPieChartConfig,
	} from './pv_setup_helper';
	import { capFirstChar } from 'src/helpers/utilities';
	// Components
	import LayerChartRenderer from '../../Chart/LayerChart/LayerChartRenderer.svelte';
	import ConsumptionContainer from '../ConsumptionContainer.svelte';
	// Types
	import type { ChartConfig, ChartDataInterface } from 'src/types/Chart';
	import type { ChartControlsDataInterface } from 'src/helpers/statistics/ui/chart_control_helpers';
	import type { PVSetupTypes } from './pv_setup_helper';
	export let chartControlsData: ChartControlsDataInterface;
	export let pvSetupType: PVSetupTypes;

	const chartConfig: ChartConfig = getPVSetupChartsConfig();
	const title: string = capFirstChar(
		$format('label_pv_report', {
			default: 'PV',
		}),
	);

	let resolvedChartData: ChartDataInterface | undefined;

	const getStatsPeriod = async (
		data: ChartControlsDataInterface,
		pvSetupType: PVSetupTypes,
	): Promise<ChartDataInterface> => {
		resolvedChartData = undefined;
		if (data && pvSetupType) {
			const pvSetupDevices = getPVSetupDevices(pvSetupType);
			const result = await getPVSetupByType(
				pvSetupDevices.gridDevices,
				pvSetupDevices.solarDevices,
				pvSetupType,
				chartConfig,
				data,
			);
			resolvedChartData = result;
			return result;
		}
	};

	const getPieTitle = (pvSetupType: PVSetupTypes) => {
		const formatKey = `option_${chartControlsData.currentPeriod}`;
		return `${title} ${pvSetupType} - ${$format(formatKey)}`;
	};

	$: statsData = getStatsPeriod(chartControlsData, pvSetupType);
</script>

{#if statsData}
	{#if resolvedChartData?.totalConsumption && title}
		<div class="d-flex align-items-center justify-content-between">
			<Text class="text-bold width-full" noWrap style="text-indent:32px">
				{getPieTitle(pvSetupType)}
			</Text>
		</div>
	{/if}
	<ConsumptionContainer fullContainer>
		{#await statsData}
			{#if title}
				<div class="mb-s d-flex align-items-center">
					<Text class="text-bold width-full" style="margin-right:-32px">
						{getPieTitle(pvSetupType)}
					</Text>
					<IconButton
						variant="secondary"
						icon="far fa-file-arrow-down"
						disabled={true}
						aria-label={$format('button_download_chart_data', {
							default: 'Download chart data',
						})}
					/>
				</div>
			{/if}
			<div
				class="d-flex justify-content-center align-items-center"
				style={`height: ${chartConfig.height}px`}
			>
				<Loader size="m" />
			</div>
		{:then chartData}
			{#if chartData?.totalConsumption}
				<div class="d-flex flex-direction-column height-full justify-content-center">
					<LayerChartRenderer
						chartData={getPVPieChartConfig(
							chartData.totalConsumption.concat(chartData?.totalReturnedConsumption || []),
						)}
					/>
				</div>
			{/if}
		{:catch error}
			<div
				class="d-flex justify-content-center align-items-center"
				style={`height: ${chartConfig.height}px`}
			>
				<Text class="body-small-styles text-center mt-m mb-s ">
					<i class="fas fa-exclamation-triangle text-warning mr-xs"></i>
					{error.message}
				</Text>
			</div>
		{/await}
	</ConsumptionContainer>
{/if}
